/* Shopify calculates flat country delivery for the current cookie cart.
 * Representative destinations are quote-only: never save them to cart/customer
 * or pass them to checkout. Shopify handles all currency conversion. */
(function () {
  'use strict';
  var generation = 0;
  var refreshTimer = null;
  var cartItemCount = null;
  var state = { status: 'pending', rates: [], rate: null };
  function destinationFor(country) {
    // Flat country rates do not need the buyer's address. These representative
    // postal destinations satisfy Shopify's validation where one is required.
    var samples = {
      AD: {zip:'AD500'},
      BG: {zip:'1000'},
      CZ: {zip:'110 00'},
      HU: {zip:'1051'},
      PL: {zip:'00-001'},
      AR: {province:'C',zip:'C1001'},
      BM: {zip:'HM 12'},
      BR: {province:'SP',zip:'01001-000'},
      CL: {province:'RM'},
      CY: {zip:'1010'},
      EE: {zip:'10111'},
      EG: {province:'C'},
      GG: {zip:'GY1 1AA'},
      GR: {zip:'10558'},
      HK: {province:'HK'},
      HR: {zip:'10000'},
      IS: {zip:'101'},
      KR: {province:'KR-11',zip:'04524'},
      LT: {zip:'01100'},
      LU: {zip:'1111'},
      LV: {zip:'LV-1050'},
      MT: {zip:'VLT 1117'},
      RO: {province:'B',zip:'010011'},
      SG: {zip:'018956'},
      SI: {zip:'1000'},
      SK: {zip:'811 01'},
      GP: {zip:'97110'},
      ID: {province:'JK',zip:'10110'},
      IM: {zip:'IM1 1AA'},
      IN: {province:'DL',zip:'110001'},
      JE: {zip:'JE2 3AA'},
      KW: {province:'KW-KU'},
      MC: {zip:'98000'},
      ME: {zip:'81000'},
      MX: {province:'DF',zip:'06000'},
      MY: {province:'KUL',zip:'50000'},
      NC: {zip:'98800'},
      NG: {province:'LA'},
      PA: {province:'PA-8'},
      PE: {province:'PE-LMA'},
      PH: {province:'PH-00',zip:'1000'},
      TH: {province:'TH-10',zip:'10200'},
      TR: {province:'TR-34'},
      ZA: {province:'GP',zip:'2000'},
      AE: {province:'DU'}, AT: {zip:'1010'}, AU: {province:'NSW',zip:'2000'}, BE: {zip:'1000'},
      CA: {province:'ON',zip:'M5V 2T6'}, CH: {zip:'8001'}, DE: {zip:'10115'},
      DK: {zip:'1050'}, ES: {province:'M',zip:'28001'}, FI: {zip:'00100'}, FR: {zip:'75001'},
      GB: {zip:'SW1A 1AA'}, IE: {province:'D',zip:'D02 X285'}, IT: {province:'RM',zip:'00118'},
      JP: {province:'13',zip:'100-0001'}, NL: {zip:'1012 AB'}, NO: {zip:'0150'}, NZ: {zip:'1010'}, PT: {province:'PT-11',zip:'1100-001'},
      SE: {zip:'111 20'}, US: {province:'NY',zip:'10001'}
    };
    return Object.assign({country:country}, samples[country] || {});
  }
  var activeController = null;
  function context() {
    var box = document.querySelector('[data-native-shipping-calculator]');
    return { country: String(window.Shopify && window.Shopify.country || box && box.dataset.marketCountry || '').toUpperCase(),
      currency: String(window.Shopify && window.Shopify.currency && window.Shopify.currency.active || box && box.dataset.marketCurrency || '').toUpperCase() };
  }
  function fingerprint(cart) {
    // Shopify may regenerate application IDs/timestamps on an unchanged cart.
    // Compare the rule and allocated value, retaining line keys and all prices.
    function discount(application) {
      if (!application) return application;
      return [application.type, application.title, application.value, application.value_type,
        application.allocation_method, application.target_selection, application.target_type,
        application.total_allocated_amount];
    }
    return JSON.stringify([cart.currency, cart.total_price, cart.items, (cart.cart_level_discount_applications || []).map(discount), cart.attributes], function (key, value) {
      if (key === 'discount_application') return discount(value);
      if (key === 'cart_level_discount_applications') return value && value.map(discount);
      return value;
    });
  }
  function publish(next) {
    state = Object.assign({cartItemCount: cartItemCount}, next);
    render();
    document.dispatchEvent(new CustomEvent('dsrcv:cart-shipping-updated'));
  }
  function render() {
    var market = context();
    document.querySelectorAll('[data-native-shipping-calculator]').forEach(function (box) {
      var country = box.querySelector('[data-native-shipping-country]');
      if (country) country.textContent = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames([document.documentElement.lang || 'en'], {type:'region'}).of(market.country) : market.country;
      var select = box.querySelector('[data-native-shipping-services]');
      if (select) {
        var signature = JSON.stringify(state.rates);
        if (select.dataset.rates !== signature) {
          select.replaceChildren();
          var prompt = document.createElement('option');
          prompt.value = ''; prompt.textContent = 'Choose delivery service'; select.appendChild(prompt);
          state.rates.forEach(function (rate, index) {
            var option = document.createElement('option'); option.value = String(index);
            option.textContent = rate.methodLabel + ' — ' + new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency', currency: rate.currency
            }).format(rate.priceCents / 100);
            select.appendChild(option);
          });
          select.dataset.rates = signature;
        }
        select.value = state.rate ? String(state.rates.indexOf(state.rate)) : '';
        select.hidden = state.rates.length < 2;
      }
      box.dataset.country = market.country;
    });
  }
  function normalize(rates, cart, market) {
    if (!Array.isArray(rates)) throw new Error('invalid_rates');
    // Shopify's prediction layer is a fallback, not a configured delivery
    // service. Keep real services in a mixed response, but never use a
    // prediction as a confirmed charge or add it to Total.
    var services = rates.filter(function (rate) {
      return rate.code !== 'backup_rate' && rate.source !== 'shopify_provided_checkout_prediction_layer';
    });
    if (rates.length && !services.length) throw new Error('checkout_required');
    return services.map(function (rate) {
      var currency = String(rate.currency || '').toUpperCase();
      var price = String(rate.price);
      var amount = Number(price);
      if (currency !== market.currency) throw new Error('currency_unavailable');
      if (!/^\d+(?:\.\d{1,2})?$/.test(price) ||
          !Number.isSafeInteger(Math.round(amount * 100)) || amount < 0 || !rate.name) throw new Error('invalid_rate');
      return { priceCents: Math.round(amount * 100), currency: currency, countryCode: market.country,
        subtotalCents: cart.total_price, methodLabel: String(rate.presentment_name || rate.name), source: 'shopify' };
    });
  }
  async function refresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = null;
    var current = ++generation;
    cartItemCount = null;
    if (activeController) activeController.abort();
    var market = context();
    var address = destinationFor(market.country);
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    activeController = controller;
    publish({ status: 'pending', rates: [], rate: null });
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/').replace(/\/$/, '');
    var params = new URLSearchParams();
    Object.keys(address).forEach(function (key) { if (address[key]) params.set('shipping_address[' + key + ']', address[key]); });
    var timeout;
    var ended = false;
    var deadline = new Promise(function (_, reject) {
      timeout = window.setTimeout(function () { reject(new Error('timeout')); if (controller) controller.abort(); }, 12000);
    });
    function json(path, method) {
      return fetch(root + path + '?' + params.toString(), {
        method: method || 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined
      }).catch(function (error) {
        if (error.name === 'TypeError') error.retryable = true;
        throw error;
      }).then(function (response) {
        if (!response.ok) {
          var error = new Error('rate_request_failed');
          error.retryable = response.status === 429 || response.status >= 500;
          throw error;
        }
        if (method === 'POST') return null; // prepare returns an empty 202 body.
        return response.json();
      });
    }
    function readCart() {
      return fetch(root + '/cart.js', { credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined }).then(function (response) {
        if (!response.ok) throw new Error('cart_request_failed'); return response.json();
      });
    }
    function isCurrent() { var now = context(); return !ended && current === generation && market.country === now.country && market.currency === now.currency; }
    try {
      var result = await Promise.race([(async function () {
        var cart = await readCart();
        if (cart.currency !== market.currency || !Number.isSafeInteger(cart.total_price)) throw new Error('cart_context_invalid');
        if (!isCurrent()) return null;
        cartItemCount = (cart.items || []).reduce(function (count, item) { return count + item.quantity; }, 0);
        if (cartItemCount === 0) return [];
        var rates;
        // Carrier calculation can briefly return no services or fail before
        // recovering. Retry once within the same deadline and cart context.
        for (var attempt = 0; attempt < 2; attempt++) {
          try {
            await json('/cart/prepare_shipping_rates.json', 'POST');
            var payload = null;
            while (isCurrent()) {
              payload = await json('/cart/async_shipping_rates.json');
              if (payload !== null) break;
              await new Promise(function (resolve) { window.setTimeout(resolve, 500); });
            }
            if (!isCurrent()) return null;
            try {
              rates = normalize(payload && payload.shipping_rates, cart, market);
            } catch (error) {
              if (error.message !== 'currency_unavailable' && error.message !== 'checkout_required') throw error;
              var predictionFallback = error.message === 'checkout_required';
              // Carrier async results can remain in shop currency. The synchronous
              // Shopify endpoint applies Markets conversion/rounding itself. Make
              // one bounded request, then retain the same explicit currency guard.
              // The same request can replace a prediction with a configured rate;
              // if it still returns a fallback, leave final delivery to checkout.
              payload = await json('/cart/shipping_rates.json');
              if (!isCurrent()) return null;
              rates = normalize(payload && payload.shipping_rates, cart, market);
              if (predictionFallback && !rates.length) throw new Error('checkout_required');
            }
          } catch (error) {
            if (!isCurrent()) return null;
            if (attempt !== 0 || error.retryable !== true) throw error;
            continue;
          }
          if (rates.length || attempt !== 0) break;
        }
        var after = await readCart();
        if (fingerprint(cart) !== fingerprint(after)) throw new Error('cart_changed');
        return rates;
      })(), deadline]);
      if (!isCurrent() || !result) return;
      publish({ status: result.length === 0 ? 'no_rates' : result.length === 1 ? 'available' : 'selection_required',
        rates: result, rate: result.length === 1 ? result[0] : null });
    } catch (error) {
      if (isCurrent()) publish({ status: ['currency_unavailable', 'checkout_required'].indexOf(error.message) !== -1 ? error.message : 'error', rates: [], rate: null });
    } finally {
      ended = true;
      window.clearTimeout(timeout);
      if (controller) controller.abort();
      if (current === generation) activeController = null;
    }
  }
  window.dsrcvCartShipping = { getState: function () { return state; }, refresh: refresh, render: render, destinationFor: destinationFor };
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-native-ucd-shipping-retry]');
    if (!button) return;
    event.preventDefault();
    refresh();
  });
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-native-shipping-services]')) {
      var value = event.target.value;
      var rate = /^\d+$/.test(value) ? state.rates[Number(value)] : null;
      publish({ status: rate ? 'available' : 'selection_required', rates: state.rates, rate: rate || null });
    }
  });
  function scheduleRefresh() {
    // A cart mutation can emit several legacy/native events. Invalidate at once,
    // then coalesce them into one quote after the basket update settles.
    ++generation;
    cartItemCount = null;
    if (activeController) activeController.abort();
    window.clearTimeout(refreshTimer);
    publish({ status: 'pending', rates: [], rate: null });
    refreshTimer = window.setTimeout(function () { refreshTimer = null; refresh(); }, 100);
  }
  ['cart:refresh', 'cart:updated', 'cart:request:success', 'cart:change', 'currency:change', 'covCurrency:updated', 'product:added', 'native-ucd:product-added'].forEach(function (event) {
    document.addEventListener(event, scheduleRefresh);
  });
  function init() {
    refresh();
    if (typeof MutationObserver === 'function') new MutationObserver(scheduleRefresh).observe(document.body, { attributes: true, attributeFilter: ['data-country'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
